import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "company-info",
  relative: ""
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = { class: "name ellipsis" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "actions",
  clickable: ""
}
const _hoisted_8 = { class: "industry" }
const _hoisted_9 = { class: "text ellipsis" }
const _hoisted_10 = { class: "hq-address" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_el_image = _resolveComponent("el-image")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_SaveDoc = _resolveComponent("SaveDoc")
  const _component_FollowBtn = _resolveComponent("FollowBtn")
  const _component_MdContent = _resolveComponent("MdContent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" IMAGE "),
      _createVNode(_component_el_image, {
        class: "image",
        fit: "contain",
        src: $options.logo_url
      }, {
        error: _withCtx(() => [
          ($props.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                shape: "circle",
                width: "10rem",
                height: "10rem",
                "border-radius": "1.6rem"
              }))
            : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                class: "placeholder",
                fit: "contain",
                src: "assets/company-placeholder.png"
              }))
        ]),
        placeholder: _withCtx(() => [
          ($props.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                shape: "circle",
                width: "10rem",
                height: "10rem",
                "border-radius": "1.6rem"
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["src"]),
      _createCommentVNode(" INFO "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" NAME "),
          _createElementVNode("div", _hoisted_5, [
            ($options.name)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: $options.name
                }, null, 8 /* PROPS */, _hoisted_6))
              : (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "3.6rem"
                }))
          ]),
          _createCommentVNode(" ACTIONS "),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Tooltip, { text: "View website" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "action-icon pointer",
                  disabled: !$options.website_url,
                  icon: "globe-02",
                  "stroke-width": "1",
                  hoverable: "",
                  stroke: "var(--gray-600)",
                  width: "2rem",
                  height: "2rem",
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.openWebsite()), ["stop"]))
                }, null, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Tooltip, { text: "View Linkedin" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "action-icon pointer",
                  disabled: !$options.linkedin_url,
                  icon: "social/linkedin-circle",
                  width: "2rem",
                  height: "2rem",
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.openLinkedin()), ["stop"]))
                }, null, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            }),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_SaveDoc, {
                  key: 0,
                  disabled: $props.loading,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                  onSave: _cache[3] || (_cache[3] = $event => (_ctx.$emit('save', $event)))
                }, null, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_Tooltip, {
              text: $options.following ? 'Unfollow' : 'Follow'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FollowBtn, {
                  following: $options.following,
                  onClick: _withModifiers($options.followCompany, ["stop"])
                }, null, 8 /* PROPS */, ["following", "onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createCommentVNode(" INDUSTRY "),
        _createElementVNode("div", _hoisted_8, [
          ($options.industry)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($options.industry_icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      width: "1.6rem",
                      height: "1.6rem",
                      stroke: "var(--gray-700)",
                      icon: $options.industry_icon
                    }, null, 8 /* PROPS */, ["icon"]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_9, _toDisplayString($options.industry_title), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "1.8rem"
                }))
              : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" ADDRESS "),
        _createElementVNode("div", _hoisted_10, [
          ($options.hq_address)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Icon, {
                  icon: "marker-pin-01",
                  stroke: "var(--gray-700)",
                  width: "1.6rem",
                  height: "1.6rem"
                }),
                _createElementVNode("div", {
                  class: "hq-text ellipsis",
                  innerHTML: $options.hq_address
                }, null, 8 /* PROPS */, _hoisted_11)
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  width: "100%",
                  height: "1.4rem"
                }))
              : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" DESCRIPTION "),
    ($options.summary)
      ? (_openBlock(), _createBlock(_component_MdContent, {
          key: 0,
          markdown: $options.summary,
          class: "bio"
        }, null, 8 /* PROPS */, ["markdown"]))
      : ($props.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 1,
            class: "bio",
            width: "100%",
            height: "2.4rem"
          }))
        : _createCommentVNode("v-if", true)
  ]))
}